// Validation utility functions for Partner Dashboard

export const validateEmail = (email: string): string | null => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!email) return 'Email is required';
  if (!emailRegex.test(email)) return 'Invalid email format';
  return null;
};

export const validatePhone = (phone: string): string | null => {
  const phoneRegex = /^[0-9]{10}$/;
  if (!phone) return 'Phone number is required';
  if (!phoneRegex.test(phone)) return 'Phone number must be exactly 10 digits';
  return null;
};

export const validatePassword = (password: string): string | null => {
  if (!password) return 'Password is required';
  if (password.length < 8) return 'Password must be at least 8 characters';
  if (!/[A-Z]/.test(password)) return 'Password must contain at least one uppercase letter';
  if (!/[a-z]/.test(password)) return 'Password must contain at least one lowercase letter';
  if (!/[0-9]/.test(password)) return 'Password must contain at least one number';
  if (!/[!@#$%^&*]/.test(password)) return 'Password must contain at least one special character (!@#$%^&*)';
  return null;
};

export const validateGSTIN = (gstin: string): string | null => {
  if (!gstin) return null; // Optional field
  const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  if (!gstinRegex.test(gstin)) {
    return 'Invalid GSTIN format. Example: 29ABCDE1234F1Z5';
  }
  return null;
};

export const validatePAN = (pan: string): string | null => {
  if (!pan) return null; // Optional field
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  if (!panRegex.test(pan)) {
    return 'Invalid PAN format. Example: ABCDE1234F';
  }
  return null;
};

export const validatePincode = (pincode: string): string | null => {
  const pincodeRegex = /^[0-9]{6}$/;
  if (!pincode) return 'Pincode is required';
  if (!pincodeRegex.test(pincode)) return 'Pincode must be exactly 6 digits';
  return null;
};

export const validateIFSC = (ifsc: string): string | null => {
  if (!ifsc) return null; // Optional field
  const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  if (!ifscRegex.test(ifsc)) {
    return 'Invalid IFSC code format. Example: SBIN0001234';
  }
  return null;
};

export const validateRequired = (value: string, fieldName: string, minLength: number = 2): string | null => {
  if (!value || value.trim().length === 0) return `${fieldName} is required`;
  if (value.trim().length < minLength) return `${fieldName} must be at least ${minLength} characters`;
  return null;
};

export const validateLatitude = (lat: number): string | null => {
  if (lat === undefined || lat === null) return 'Latitude is required';
  if (lat < -90 || lat > 90) return 'Latitude must be between -90 and 90';
  return null;
};

export const validateLongitude = (lng: number): string | null => {
  if (lng === undefined || lng === null) return 'Longitude is required';
  if (lng < -180 || lng > 180) return 'Longitude must be between -180 and 180';
  return null;
};
